import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMySubscription } from "../features/user/subscriptionThunks";
import { logoutMerchant } from "../features/merchant/merchantThunks";
import featureFlags from "../config/featureFlags";

const SubscriptionRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, loading: authLoading } = useSelector((s) => s.merchant);
  const { mySubscription, loadingMySubscription } = useSelector(
    (s) => s.subscription
  );

  // Check role-specific subscription flag — bypass if disabled for this role
  const subscriptionEnabled =
    user?.role === "merchant"
      ? featureFlags.ENABLE_MERCHANT_SUBSCRIPTION
      : featureFlags.ENABLE_USER_SUBSCRIPTION;

  if (!subscriptionEnabled) {
    return <Outlet />;
  }

  // Wait for auth restore
  if (authLoading) {
    return <p style={{ padding: 20 }}>Checking authentication...</p>;
  }

  useEffect(() => {
    if (!mySubscription) {
      dispatch(fetchMySubscription());
    }
  }, [dispatch]);

  // ⏳ WAIT for subscription fetch
  if (loadingMySubscription) {
    return <p style={{ padding: 20 }}>Checking subscription...</p>;
  }

  if (!mySubscription) {
    navigate("/buy-subscription", { replace: true });
    return null;
  }

  const expiry = mySubscription.expiryDate
    ? new Date(mySubscription.expiryDate)
    : null;

  const isExpired = !expiry || expiry.getTime() < Date.now();
  const isPaid = mySubscription.payment_status === "paid";

  if (isExpired || !isPaid) {
    navigate("/buy-subscription", { replace: true });
    return null;
  }

  return <Outlet />;
};


export default SubscriptionRoute;
